import { Grid, Stack } from "@mui/material";
import { CaseInfoItem } from "@/features/case/components/CaseBasicInfo/CaseInfoItem";
import { Button } from "@/components/elements/Button";
import { TGetJobDto } from "@/api/services/main/job/dtos/get-job.dto";
import { FCC } from "@/types/common";
import { Link } from "react-router-dom";
import { AppRoutes } from "@/routes/config";
import { convertNumberToCommas } from "@/utils/input";
import { findLabelByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";

type TCaseJobInfoProps = {
  jobInfo: TGetJobDto;
};

export const CaseJobInfo: FCC<TCaseJobInfoProps> = ({ jobInfo }) => {
  const { id, companySpecificIndustry, workplace, workplaceDetail, recruitmentNumber, memo, salaryType, baseSalary } = jobInfo;
  const workAddress = `${workplace} ${workplaceDetail ?? ""}`;
  const { data: salaryTypeOptions } = useEnum("ESalaryType");

  const urlJobDetail = AppRoutes.jobEdit.replaceAll(":jobId", String(id));

  const salary = baseSalary ? `${findLabelByValue(salaryTypeOptions, salaryType)} ${convertNumberToCommas(baseSalary.toString())}円` : null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <CaseInfoItem label="分野" value={companySpecificIndustry?.companySpecificIndustry} />
      </Grid>
      <Grid item xs={3}>
        <CaseInfoItem label="給与" value={salary} />
      </Grid>
      <Grid item xs={3}>
        <CaseInfoItem label="勤務地" value={workAddress} />
      </Grid>
      <Grid item xs={3}>
        <CaseInfoItem label="募集人数" value={recruitmentNumber + "人"} />
      </Grid>
      <Grid item xs={12}>
        <CaseInfoItem label="特性メモ" value={memo} />
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" spacing={2} justifyContent={"end"}>
          <Button component={Link} to={urlJobDetail} variant="ghost" target="_blank">
            詳細を見る
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};
